import React from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
import { blue_pilu, whichEnvURL, white_pilu } from '../../../helpers/utils';
import { useNavigate } from 'react-router-dom';

// Generate Order Data
function createData(id, date, name, shipTo, paymentMethod, amount) {
	return { id, date, name, shipTo, paymentMethod, amount };
}

const path = '/dashboard/ordenes';

const useStyles = makeStyles((theme) => ({
	seeMore: {
		marginTop: theme.spacing(3),
	},
}));

export default function Orders({
	name = '',
	columns = [],
	rows = [],
	link = false,
}) {
	const navigate = useNavigate();
	const classes = useStyles();
	return (
		<React.Fragment>
			<Title>{name}</Title>
			<Table size='small'>
				<TableHead>
					<TableRow
						style={{
							backgroundColor: blue_pilu,
						}}
					>
						{columns.map((item, index) => (
							<TableCell
								key={index}
								style={{ color: white_pilu }}
							>
								{item}
							</TableCell>
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{rows.map((row, index) => (
						<TableRow key={index}>
							<TableCell>{row.col1}</TableCell>
							{row.col2?.name ? (
								<TableCell>
									<p
										style={{
											color: blue_pilu,
											cursor: 'pointer',
										}}
										onClick={() => {
											const path = `/dashboard/order/${row.col2.id}`;
											navigate(path);
										}}
									>
										{row.col2.name}
									</p>
								</TableCell>
							) : (
								<>
									{row?.col2 && (
										<TableCell>{row.col2}</TableCell>
									)}
								</>
							)}

							{row?.col3 && <TableCell>{row.col3}</TableCell>}
							{row?.col4 && <TableCell>{row.col4}</TableCell>}
							{row?.col5 && <TableCell>{row.col5}</TableCell>}
							{row?.col6 && <TableCell>{row.col6}</TableCell>}
						</TableRow>
					))}
				</TableBody>
			</Table>
			{link && (
				<div className={classes.seeMore}>
					<p
						style={{ color: blue_pilu, cursor: 'pointer' }}
						onClick={() => {
							localStorage.setItem('lastPathPilu', path);
							navigate(path);
						}}
					>
						Ver más pedidos
					</p>
				</div>
			)}
		</React.Fragment>
	);
}
